import placeHolder from '../../images/Cup-Placeholder.webp';
import foodHolder from '../../images/Food-Placeholder.png';

const MENU = [
    {
        milkTea: [
            {
                img : placeHolder,
                title : 'Classic Milk Tea',
                desc : 'A timeless favorite, our creamy milk tea infused with black tea and served with chewy boba pearls for a delightful texture contrast.',
                calories : '150 calories',
                ingredients : 'black tea, milk, boba pearls',
                price: '$5.99',
                key : 1
            },
            {
                img : placeHolder,
                title : 'Taro Boba Milk Tea',
                desc : 'Indulge in the exotic flavor of taro root combined with creamy milk and chewy boba pearls for a uniquely satisfying experience.',
                calories : '180 calories',
                ingredients : 'taro root, milk, boba pearls',
                price: '$6.49',
                key : 2
            },
            {
                img : placeHolder,
                title : 'Matcha Milk Tea',
                desc : 'Dive into the world of matcha with this vibrant green tea, featuring the earthy taste of premium matcha powder and creamy milk.',
                calories : '160 calories',
                ingredients : 'matcha powder, milk',
                price: '$6.99',
                key : 3
            },
            {
                img : placeHolder,
                title : 'Brown Sugar Boba Milk Tea',
                desc : 'Creamy milk tea sweetened with rich brown sugar syrup and paired with chewy boba pearls for a decadent and satisfying drink.',
                calories : '200 calories',
                ingredients : 'brown sugar syrup, milk, boba pearls',
                price: '$7.49',
                key : 4
            }
        ]
    },
    {
        icedTea: [
            {
                img : placeHolder,
                title : 'Honeydew Lychee Iced Tea',
                desc : 'Crisp and refreshing iced tea infused with the sweet essence of honeydew melon, enhanced with the addition of lychee pearls for a delightful chewy experience.',
                calories : '120 calories',
                ingredients : 'honeydew melon, lychee pearls, black tea',
                price: '$4.99',
                key : 5
            },
            {
                img : placeHolder,
                title : 'Peach Blossom Iced Tea',
                desc : 'Crisp black tea infused with the essence of sun-ripened peaches, served over ice for a refreshing summer sip.',
                calories : '100 calories',
                ingredients : 'peaches, black tea',
                price: '$5.49',
                key : 6
            },
            {
                img : placeHolder,
                title : 'Blueberry Lavender Iced Tea',
                desc : 'A refreshing infusion of black tea, sweet blueberries, and fragrant lavender, served chilled for a harmonious balance of flavors.',
                calories : '110 calories',
                ingredients : 'blueberries, lavender, black tea',
                price: '$5.99',
                key : 7
            },
            {
                img : placeHolder,
                title : 'Watermelon Mint Iced Tea',
                desc : 'Cool and crisp iced tea infused with the juiciness of fresh watermelon and the invigorating essence of mint leaves.',
                calories : '100 calories',
                ingredients : 'watermelon, mint leaves, black tea',
                price: '$5.49',
                key : 8
            }
        ]
    },
    {
        hotTea: [
            {
                img: placeHolder,
                title: 'Spiced Chai Tea',
                desc: 'A warming blend of black tea infused with aromatic spices like cinnamon, cardamom, and cloves, steeped in hot water and finished with a splash of creamy milk for a comforting and indulgent beverage.',
                calories: '90 calories',
                ingredients: 'black tea, cinnamon, cardamom, cloves, milk',
                price: '$4.99',
                key: 9
            },
            {
                img: placeHolder,
                title: 'Earl Grey Tea',
                desc: 'Classic black tea scented with the essence of bergamot oranges, offering a citrusy and floral aroma with every sip, perfect for a soothing and elegant tea-drinking experience.',
                calories: '0 calories',
                ingredients: 'black tea, bergamot oranges',
                price: '$4.49',
                key: 10
            },
            {
                img: placeHolder,
                title: 'Green Jasmine Tea',
                desc: 'Fragrant green tea leaves scented with delicate jasmine blossoms, creating a light and floral brew that\'s both soothing and uplifting, perfect for moments of relaxation and rejuvenation.',
                calories: '5 calories',
                ingredients: 'green tea leaves, jasmine blossoms',
                price: '$5.49',
                key: 11
            },
            {
                img: placeHolder,
                title: 'Vanilla Rooibos Tea',
                desc: 'Smooth and naturally sweet rooibos tea infused with creamy vanilla notes, offering a caffeine-free alternative that\'s perfect for any time of day.',
                calories: '0 calories',
                ingredients: 'rooibos tea, vanilla',
                price: '$5.99',
                key: 12
            }
        ]
    },
    {
        slush: [
            {
                img : placeHolder,
                title : 'Mango Boba Slush',
                desc : 'Cool off with our tropical mango slush, blended with ice and mango puree, and finished with a generous serving of boba pearls for added sweetness and texture.',
                calories : '220 calories',
                ingredients : 'mango, ice, mango puree, boba pearls',
                price: '$6.49',
                key : 13
            },
            {
                img : placeHolder,
                title : 'Strawberry Lychee Slush',
                desc : 'Experience the taste of summer with this luscious strawberry smoothie, bursting with the flavor of ripe strawberries and topped with whipped cream.',
                calories : '180 calories',
                ingredients : 'strawberries, lychee, whipped cream',
                price: '$5.99',
                key : 14
            },
            {
                img : placeHolder,
                title : 'Cookies and Cream Slush',
                desc : 'Indulgent milk tea blended with crushed cookies and creamy vanilla ice cream, creating a decadent slushy dessert drink that\'s sure to satisfy any sweet tooth.',
                calories : '250 calories',
                ingredients : 'milk tea, cookies, vanilla ice cream',
                price: '$7.49',
                key : 15
            },
            {
                img : placeHolder,
                title : 'Passionfruit Green Tea Slush',
                desc : 'Tangy passionfruit blended with refreshing green tea and ice, creating a vibrant and invigorating slushy beverage perfect for a sunny day.',
                calories : '150 calories',
                ingredients : 'passionfruit, green tea, ice',
                price: '$5.49',
                key : 16
            }
        ]
    },
    {
        lunch: [
            {
                img: foodHolder,
                title: 'Grilled Chicken Avocado Wrap',
                desc: 'Juicy grilled chicken breast, creamy avocado slices, crisp lettuce, and ripe tomatoes wrapped in a soft tortilla, served with a side of tangy salsa for a satisfying lunch option.',
                calories: '350 calories',
                ingredients: 'grilled chicken breast, avocado, lettuce, tomatoes, tortilla, salsa',
                price: '$8.99',
                key: 17
            },
            {
                img: foodHolder,
                title: 'Mediterranean Quinoa Salad',
                desc: 'A refreshing salad featuring nutty quinoa, crisp cucumbers, juicy cherry tomatoes, tangy feta cheese, and briny olives, tossed in a zesty lemon vinaigrette for a light and flavorful meal.',
                calories: '300 calories',
                ingredients: 'quinoa, cucumbers, cherry tomatoes, feta cheese, olives, lemon vinaigrette',
                price: '$9.49',
                key: 18
            },
            {
                img: foodHolder,
                title: 'Vegetable Panini with Pesto Spread',
                desc: 'Savor the flavors of summer with our vegetable panini, packed with roasted bell peppers, zucchini, eggplant, and red onions, layered with creamy pesto spread and grilled to perfection on artisanal bread.',
                calories: '380 calories',
                ingredients: 'roasted bell peppers, zucchini, eggplant, red onions, pesto spread, artisanal bread',
                price: '$10.49',
                key: 19
            }
        ]
    },
    {
        breakfast: [
            {
                img: foodHolder,
                title: 'Avocado Toast with Poached Egg',
                desc: 'Creamy avocado spread over hearty whole-grain toast, topped with a perfectly poached egg and a sprinkle of red pepper flakes for a satisfying and nutritious breakfast option.',
                calories: '280 calories',
                ingredients: 'avocado, whole-grain toast, poached egg, red pepper flakes',
                price: '$7.99',
                key: 20
            },
            {
                img: foodHolder,
                title: 'Greek Yogurt Parfait',
                desc: 'Layers of creamy Greek yogurt, crunchy granola, and sweet seasonal berries, drizzled with honey for a wholesome and protein-packed breakfast treat that will keep you energized all morning long.',
                calories: '250 calories',
                ingredients: 'Greek yogurt, granola, seasonal berries, honey',
                price: '$6.49',
                key: 21
            },
            {
                img: foodHolder,
                title: 'Spinach and Feta Breakfast Wrap',
                desc: 'Start your day right with our spinach and feta breakfast wrap, featuring fluffy scrambled eggs, sautéed spinach, tangy feta cheese, and roasted red peppers wrapped in a warm tortilla.',
                calories: '320 calories',
                ingredients: 'scrambled eggs, spinach, feta cheese, roasted red peppers, warm tortilla',
                price: '$8.49',
                key: 22
            }
        ]
    },
    {
        bakery: [
            {
                img: foodHolder,
                title: 'Blueberry Muffin',
                desc: 'Tender and moist blueberry muffin bursting with juicy blueberries in every bite, perfect for a quick and delicious breakfast or snack on the go.',
                calories: '220 calories',
                ingredients: 'blueberries, muffin batter',
                price: '$3.49',
                key: 23
            },
            {
                img: foodHolder,
                title: 'Chocolate Croissant',
                desc: 'Buttery and flaky croissant filled with rich and indulgent chocolate, baked to golden perfection for a delightful sweet treat to enjoy with your morning coffee.',
                calories: '280 calories',
                ingredients: 'croissant dough, chocolate filling',
                price: '$4.99',
                key: 24
            },
            {
                img: foodHolder,
                title: 'Cinnamon Roll',
                desc: 'Soft and fluffy cinnamon roll swirled with aromatic cinnamon sugar and topped with a sweet cream cheese glaze, guaranteed to satisfy your sweet cravings any time of day.',
                calories: '320 calories',
                ingredients: 'cinnamon sugar, cream cheese glaze',
                price: '$5.49',
                key: 25
            }
        ]
    }
];
    
export default MENU;
    
